module.exports = __webpack_public_path__ + "img/h6.b31dc108.png";